export default __webpack_public_path__ + "static/media/documents.3967c6c4.png";